import { DOCUMENT } from "@angular/common";
import { Injectable, inject } from "@angular/core";
import { Observable, fromEvent } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class RonMonitorVisibility {
  private readonly document = inject(DOCUMENT);

  readonly changes$: Observable<void> = fromEvent(
    this.document,
    "visibilitychange"
  ).pipe(map((): void => undefined));

  isVisible(): boolean {
    return this.document.visibilityState === "visible";
  }
}
